export default {
  title:        'Gestão dos meus dados',
  description:  'Correção de dados incompletos, inexatos ou desatualizados',
  instructions: 'Para atualizar seus dados por favor entre em contato com a nossa central de atendimento',
};
